import _regeneratorRuntime from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { getAssetsPackage } from '../assetsPackage';
import { Endpoints, DailyBonusResponseKeys, SpinnerItemKeys } from '../../../api/Constants';
import { handleQueryLoggerEvents } from '../../sagas/handleLoggerErrorEvents';
import Logger from '../../../lib/analytics/logger';
import { validateJson } from '../../../utils/jsonschema/validator';
import { EVENT_TYPES } from '../../../lib/analytics/constants';
import transformObjectResponseKeys from '../../../utils/transformObjectResponseKeys';
import transformObjectArrayResponse from '../../../utils/transformObjectArrayResponse';
import ERROR_CODE from '../../../utils/errorCodes';
import HTTP from '../../../utils/httpMethods';
import { getTimeout } from '../../api/services/utils/timeout';
export var getDailyWheelBonusQuery = {
  query: function query() {
    return {
      url: Endpoints.CLAIM_DAILY_BONUS,
      body: {
        timeout: getTimeout(Endpoints.CLAIM_DAILY_BONUS, HTTP.GET)
      }
    };
  },
  keepUnusedDataFor: 5
};
export var getDailyWheelDataQuery = {
  query: function query() {
    return {
      url: Endpoints.GET_DAILY_WHEEL_INFO
    };
  },
  keepUnusedDataFor: 10,
  transformResponse: function transformResponse(response) {
    try {
      if (!(response === null || response === void 0 ? void 0 : response[0]) || Object.keys(response === null || response === void 0 ? void 0 : response[0]).length === 0 && (response === null || response === void 0 ? void 0 : response[0].constructor) === Object) return false;
      if (!validateJson(Endpoints.GET_DAILY_WHEEL_INFO, response)) return false;
      return handleResponse(response[0]);
    } catch (error) {
      Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
        error: JSON.stringify(error, Object.getOwnPropertyNames(error)),
        code: ERROR_CODE.GET_DAILY_BONUS_FAIL
      });
      handleQueryLoggerEvents(error);
    }
  },
  onQueryStarted: function () {
    var _onQueryStarted = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(data, _ref) {
      var dispatch, queryFulfilled, _yield$queryFulfilled, ASSET_PACKAGE;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dispatch = _ref.dispatch, queryFulfilled = _ref.queryFulfilled;
              _context.prev = 1;
              _context.next = 4;
              return queryFulfilled;

            case 4:
              _yield$queryFulfilled = _context.sent;
              ASSET_PACKAGE = _yield$queryFulfilled.data.ASSET_PACKAGE;
              _context.t0 = ASSET_PACKAGE;

              if (!_context.t0) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return dispatch(getAssetsPackage.initiate({
                assetsPackageId: ASSET_PACKAGE
              }));

            case 10:
              _context.next = 16;
              break;

            case 12:
              _context.prev = 12;
              _context.t1 = _context["catch"](1);
              Logger.sendEvent(EVENT_TYPES.FRONTEND_ERROR, {
                error: JSON.stringify(_context.t1, Object.getOwnPropertyNames(_context.t1)),
                code: ERROR_CODE.GET_DAILY_BONUS_FAIL
              });
              handleQueryLoggerEvents(_context.t1);

            case 16:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 12]]);
    }));

    function onQueryStarted(_x, _x2) {
      return _onQueryStarted.apply(this, arguments);
    }

    return onQueryStarted;
  }()
};

var handleResponse = function handleResponse(callResponse) {
  var _callResponse$LOGIN_S;

  callResponse = transformObjectResponseKeys(callResponse, DailyBonusResponseKeys);
  callResponse.SPINNER_ITEMS = transformObjectArrayResponse(callResponse.SPINNER_ITEMS);

  for (var i = 0; i < callResponse.SPINNER_ITEMS.length; i++) {
    callResponse.SPINNER_ITEMS[i] = transformObjectResponseKeys(callResponse.SPINNER_ITEMS[i], SpinnerItemKeys);
  }

  callResponse.RESPIN_COST = parseInt(callResponse.RESPIN_COST);
  callResponse.LOGIN_STREAK_COINS_LIST = transformObjectArrayResponse(callResponse.LOGIN_STREAK_COINS_LIST);
  callResponse.LOGIN_STREAK_LOYALTY_LIST = transformObjectArrayResponse(callResponse.LOGIN_STREAK_LOYALTY_LIST);
  callResponse.LOGIN_STREAK_BONUS_LIST = [];

  for (var _i = 0; _i < callResponse.LOGIN_STREAK_COINS_LIST.length; _i++) {
    var bonus = {};
    bonus.coins = callResponse.LOGIN_STREAK_COINS_LIST[_i].display_amount;
    bonus.loyalty = callResponse.LOGIN_STREAK_LOYALTY_LIST[_i].display_amount;
    bonus.day = parseInt(callResponse.LOGIN_STREAK_LOYALTY_LIST[_i]['__sort_key']);
    callResponse.LOGIN_STREAK_BONUS_LIST.push(bonus);
  }

  callResponse.MEMBER_TIERS = transformObjectArrayResponse(callResponse.MEMBER_TIERS);

  if (((_callResponse$LOGIN_S = callResponse.LOGIN_STREAK_BONUS_LIST) === null || _callResponse$LOGIN_S === void 0 ? void 0 : _callResponse$LOGIN_S.findIndex(function (item) {
    return item.day === callResponse.CURRENT_REWARD_DAY;
  })) < 0) {
    return false;
  }

  return callResponse;
};